import React from 'react';
import { Link } from 'react-router-dom';
import MobClose from './MobClose';

const Menu = (props) => {
  return (
    <div className={props.menuClass}>
      <div className={props.menuItemClass} onClick={props.propOnClick}><Link to='/Pages'>Pages</Link><div className="underline" style={{display: props.underline}}></div></div>
      <div className={props.menuItemClass} onClick={props.propOnClick}><Link to='/Covers'>Covers</Link><div className="underline" style={{display: props.underline}}></div></div>
      <div className={props.menuItemClass} onClick={props.propOnClick}><Link to='/About'>About</Link><div className="underline" style={{display: props.underline}}></div></div>
      <div className={props.menuItemClass} onClick={props.propOnClick}><Link to='/Contact'>Contact</Link><div className="underline" style={{display: props.underline}}></div></div>
      <div id="home" className={props.menuItemClass} onClick={props.propOnClick} style={{display: props.homeDisplay}}><Link to='/'>Home</Link></div>
      <div id="close" className={props.menuItemClass} onClick={props.propOnClick} style={{display: props.closeDisplay}}><MobClose /></div>
    </div>
  )
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js